<c-button
  type="ghost"
  [fullWidth]="false"
  [disabled]="loading$ | async"
  (action)="initLanguagePicker()">
  <div class="flex gap-8">
    <c-language-item
      [loading]="loading$ | async"
      [language]="selectedLanguage$ | async"
      variant="select" />
    <img src="assets/img/down.svg" [alt]="'common.alt-image' | transloco" />
  </div>
</c-button>
